import { loadTheme, getCurrentThemeId } from 'owa-theme';

export default function previewDarkModeTheme(isDarkModeTheme: boolean) {
    loadTheme(getCurrentThemeId(), isDarkModeTheme);
}
